import { SegmentFactory } from "./SegmentFactory";

export const setSegmentId = (id) => {
  try {
    const segment = SegmentFactory.getInstance();
    segment.setId(id);
  } catch (error) {
    console.error(error);
  }
};
